export * from './paths';
export * from './keys';
export * from './masks';
export * from './validations';

export const PRODUCTION = 'production';
export const DEVELOPMENT = 'development';

export const PREFIX_MOB_PHONE = '+91';

export enum NAME_FORMS {
  CONTACT_DATA = 'CONTACT_DATA',
  PHONE_VERIFICATION = 'PHONE_VERIFICATION',
  PIN_CODE = 'PIN_CODE',
  PAN_CARD_NUMBER = 'PAN_CARD_NUMBER',
  PAN_CARD_PERSONAL_INFO = 'PAN_CARD_PERSONAL_INFO',
  EMPLOYMENT_DETAILS = 'EMPLOYMENT_DETAILS',
  ADDITIONAL_DETAILS = 'ADDITIONAL_DETAILS',
  AADHAAR_VERIFICATION = 'AADHAAR_VERIFICATION',
  IFSC_CODE = 'IFSC_CODE',
  IFCS_DATA = 'IFCS_DATA',

  AADHAAR_OTP = 'AADHAAR_OTP',

  PERSONAL_INFO = 'PERSONAL_INFO',
  PERSONAL_DATA = 'PERSONAL_DATA',
  PERMANENT_ADDRESS_DATA = 'PERMANENT_ADDRESS_DATA',
  LOGIN_PHONE = 'LOGIN_PHONE',
  BANK_STATEMENT = 'BANK_STATEMENT',
  APPLICATION_DATA = 'APPLICATION_DATA',
  REGISTRATION_DATA = 'REGISTRATION_DATA',
}

export const MAX_CUSTOMER_AGE = 75;
export const MIN_CUSTOMER_AGE = 18;
export const FORMAT_DATE_SHORT = 'dd.MM.yy';
export const FORMAT_DATE = 'dd.MM.yyyy';
export const FORMAT_DATE_FOR_TIME_ZONE = 'DD.MM.YYYY';
export const FULL_FORMAT_DATE = 'dd.MM.yyyy';
export const timeZone = 'Asia/Kolkata';

export enum LoanState {
  PENDING = 'pending',
  ACTIVE = 'active',
  CLOSED = 'closed',
  DEFAULTED = 'defaulted',
  CANCELLED = 'cancelled',
  SOLD = 'sold',
}

export enum ApplicationStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  CONFIRMED = 'confirmed',
  CANCELLED = 'cancelled',
  ERROR = 'error',
}

export enum ExperianMode {
  SKIP = 'Skip',
  FAKE = 'Fake',
  FLOW_WITH_OTP = 'flowWithOtp',
  FLOW_WITHOUT_OTP = 'flowWithoutOtp',
  FLOW_SOAP = 'Soap',
}

export enum PRODUCT_ID {
  PDLv1 = 1,
  Instalment_v1 = 2,
  PDLv2 = 3,
  PDLv3 = 4,
  Instalment_v2 = 5,
  PDLv4 = 6,
  Installment_v3 = 7,
  PDLv5 = 8,
  Installment_v4 = 9,
  Installment_v5 = 10,
  PDLv6 = 11,
  Installment_v6 = 12,
  PDLv7 = 13,
}

export enum PRODUCT_TYPE {
  PDL = 'PDL',
  INSTALLMENT = 'nstallment',
}

export const PRODUCT_PDL = PRODUCT_ID.PDLv7;
export const PRODUCT_INSTALMENT = PRODUCT_ID.Installment_v6;

export const DEFAULT_PRODUCT_PDL = PRODUCT_ID.PDLv7;
export const DEFAULT_PRODUCT_INSTALMENT = PRODUCT_ID.Installment_v6;

export const DEFAULT_EXPIRES_DAYS_COOKIES = 30;

export const PAYMENT_GATEWAY = 'cashfree';

export const DEFAULT_TERM_FOR_FIRST_LOAN = 60;
export const DEFAULT_AMOUNT_FOR_FIRST_LOAN = 1500;
export const DEFAULT_TERM_FOR_REPEATED_LOAN = 60;
export const DEFAULT_AMOUNT_FOR_REPEATED_LOAN = 20000;

export const validPhoneCodes = [9, 8, 7, 6, 5, 4, 3];

export const LOAN_SUM = 'loan_sum';
export const LOAN_TERM = 'loan_term';

export const GOOGLE_REVIEW =
  'https://search.google.com/local/writereview?placeid=ChIJyxSYC5sRrjsRhrqnTnIDnIs';
export const FEEDBACK_EMAIL = 'care@lendplus.in';

export const EXPERIAN_DISPUTE_PAGE =
  'https://consumer.experian.in/ECSINDIA-DCE/?isDCEFlow=true#!/utiERNPage';

export const ESIGN_URL_PROD = 'https://esign.zoop.one/v4/viewer/';
export const FIELD_REQUIRED = 'message_field_required';
export const FIELD_REQUIRED_PENNY_TRANSFER = 'message_field_required_penny_transfer';
export const FIELD_REQUIRED_PENNY_TRANSFER_IFSC = 'message_field_required_penny_transfer_IFSC';
export const FIELD_BAD_LENGTH = 'bad_length_name';
export const FIELD_MIN_TWO_LENGTH = 'min_2_length';
export const FIELD_MIN_FIVE_LENGTH = 'min_5_length';
export const FIELD_ALPHA_NUMERIC_SYMBOLS = 'message_alpha_numeric_and_symbols';
export const INVALID_BIRTHDAY = 'message_invalid_birthday_date';
export const MESSAGE_USERNAME_REQUIRED = 'message_username_required';
export const MESSAGE_PHONE_REQUIRED = 'message_phone_number_required';
export const MESSAGE_FIRST_NUMBER_NO_VALID = 'message_username_first_number_no_valid';
export const MESSAGE_PHONE_NUMBER_LENGTH = 'message_phone_number_length';
export const MIN_LENGTH_12 = 'message_min_twelve_length';
export const AADHAR_FIELD_LENGTH = 'message_aadhar_field_length';
export const ALERTS_DEFAULT_TIMEOUT_VALUE = 4000;
export const ALERTS_LONG_TIME_TIMEOUT_VALUE = 500000;

export enum PartnerUrl {
  LIST_CREDIT = 'https://list-credit.com/online-loan-in',
}

export enum KeyStatus {
  TRUE = 'true',
  FALSE = 'false',
}

export enum UserRegisteredStatus {
  TRUE = 'true',
  FALSE = 'false',
}

export enum KycRequestState {
  PENDING = 'pending',
  POSTPONED = 'postponed',
  PROCESSED = 'processed',
  ERROR = 'error',
}

export enum BankStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum BankAnalysisMode {
  SETU = 'setu_aa',
  SKIP = 'skip',
}

export enum ozForensics {
  plugin_liveness = 'https://web-sdk.cdn.prod.ozforensics.com/aventusindia/plugin_liveness.php',
  config = 'https://web-sdk.cdn.prod.ozforensics.com/aventusindia/config.php',
  plugin_sandbox = 'https://web-sdk.cdn.sandbox.ozforensics.com/aventusindia/plugin_liveness.php',
}

export enum cashFree {
  prod = 'https://sdk.cashfree.com/js/v3/cashfree.js',
  sandbox = '',
}

export enum fieldTypes {
  text = 'text',
  text_bold = 'text-bold',
  link = 'link',
  button = 'button',
  divider = 'divider',
}

export const AADHAAR_VERIFICATION_ENGINES = {
  DIGILOCKER: 'surepass_digilocker_aadhaar',
  AADHAAR_V2: 'surepass_aadhaar_v2',
  ZOOP_OKYC: 'zoop_okyc',
};
